<template>
  <el-tooltip v-if="auth" effec="dart" :disabled="!getContent" :content="getContent">
    <div>
      <slot></slot>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      default: () => ({})
    },
    access: {
      validator(v) {
        if (typeof v === 'function') return true;
        console.error('m-tooltip: error type is not a function');
        return false;
      },
      default: () => () => true
    },
    content: {
      type: [String, Function, null, undefined],
      default: null
    }
  },
  computed: {
    auth() {
      return this.access(this.rowData);
    },
    getContent() {
      const { rowData, content } = this;
      if (!content) return null;
      if (typeof content === 'function') return content(rowData);
      return content;
    }
  }
};
</script>

<style></style>
